import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('adminAuthToken');

  if (!isAuthenticated) {
    // User not authenticated, redirect to login
    return <Navigate to="/adminLogin" replace />;
  }

  return children;
};

export default ProtectedRoute;